// extracted by mini-css-extract-plugin
export default {"advertTab":"PfRI6Wi9"};